export enum ProductTypes {
    GENERIC, VCS, FOOD
}
